import { FloorsContainer } from '../../containers/advancedFilters/FloorsContainer';
import { IFilter } from '../../types/filters';

export const floors: IFilter = {
  component: FloorsContainer,
};
